import { createContext, useContext } from 'react';

export const HEADER_SEARCH_SLOT_ID = 'layout-header-search-slot';

export const HeaderSlotContext = createContext({
  setDesktopSearchVisible: () => {},
});

export const useHeaderSlot = () => useContext(HeaderSlotContext);

